import React from "react";
import { StatusBadge } from "../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../shared/components/ui/ExpandedAccordion";

const AppointmentExpandRow = ({ item }) => {
  // const sections = [
  //   {
  //     id: "child",
  //     title: "Child Information",
  //     fields: [
  //       { label: "Gender", value: item.childGender || "—" },
  //       {
  //         label: "DOB",
  //         value: item.dateOfBirth
  //           ? new Date(item.dateOfBirth).toLocaleDateString("en-US", {
  //               month: "short",
  //               day: "numeric",
  //               year: "numeric",
  //             })
  //           : "—",
  //       },
  //       { label: "Weight", value: item.weight ? `${item.weight} kg` : "—" },
  //       { label: "Blood Group", value: item.bloodGroup || "—" },
  //     ],
  //   },
  //   {
  //     id: "parent",
  //     title: "Parent Information",
  //     fields: [
  //       { label: "Name", value: item.parentName || "—" },
  //       { label: "Email", value: item.parentEmail || "—" },
  //       { label: "Phone", value: item.parentPhone || "—" },
  //       { label: "Relation", value: item.relationWithChild || "—" },
  //       { label: "Address", value: item.address || "—", isLong: true },
  //     ],
  //   },
  //   {
  //     id: "appointment",
  //     title: "Appointment Details",
  //     fields: [
  //       {
  //         label: "Date & Time",
  //         value:
  //           item.appointmentDate && item.appointmentTime
  //             ? `${new Date(item.appointmentDate).toLocaleDateString("en-US", {
  //                 month: "short",
  //                 day: "numeric",
  //                 year: "numeric",
  //               })} at ${item.appointmentTime}`
  //             : "—",
  //       },

  //       { label: "Doctor", value: item.doctor || "—" },
  //       { label: "Center", value: item.center || "—" },
  //       { label: "Priority", value: item.priority || "—" },
  //       { label: "Notes", value: item.notes || "—", isLong: true },
  //     ],
  //   },
  // ];
  const sections = [
    {
      id: "parent",
      title: "Parent Information",
      fields: [
        { label: "Parent Name", value: item.data.parent?.fullName || item.parentName || "—" },
        { label: "Child Name", value: item.child?.name || item.childName || "—" },
      ],
    },
    {
      id: "appointment",
      title: "Appointment Details",
      fields: [
        { label: "Vaccine Name", value: item.vaccine?.name || item.vaccineName || "—" },
        {
          label: "Appointment Date",
          value: item.scheduledDate
            ? new Date(item.scheduledDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "—",
        },
        { label: "Appointment Time", value: item.scheduledTime || "—" },
        { label: "Vaccination Center", value: item.vaccinationCenter?.name || item.center || "Default Clinic" },
        { label: "Notes", value: item.notes || "—", isLong: true },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default AppointmentExpandRow;
